import { render, staticRenderFns } from "./MandateDataNTPI.vue?vue&type=template&id=6d51f562&scoped=true&"
import script from "./MandateDataNTPI.vue?vue&type=script&lang=js&"
export * from "./MandateDataNTPI.vue?vue&type=script&lang=js&"
import style0 from "./MandateDataNTPI.vue?vue&type=style&index=0&id=6d51f562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51f562",
  null
  
)

export default component.exports